import PhotoSwipe from "photoswipe";
import PhotoSwipeLightbox from "photoswipe/lightbox";

import "photoswipe/style.css";

const PhotoswipeInit = () => {
  // Anchors are rendered by the Media/Type/Image.html partial when
  // tt_content.image_zoom is set; all images of one content element
  // (.ce-gallery) are grouped into a single gallery.
  const lightbox = new PhotoSwipeLightbox({
    gallery: ".ce-gallery",
    children: "a.lightbox",
    pswpModule: PhotoSwipe,
    closeTitle: "Schließen",
    zoomTitle: "Zoomen",
    arrowPrevTitle: "Vorheriges Bild",
    arrowNextTitle: "Nächstes Bild",
    errorMsg: "Das Bild kann nicht geladen werden",
  });

  lightbox.init();
};

export default PhotoswipeInit;
